import { api } from "@/lib/api"
import { AnalyticsChart } from "./analytics-chart"

export function WorkspaceCreationChart() {
	const workspaceChartQuery = api.analytics.workspaceCreationChart.useQuery({})

	return (
		<AnalyticsChart
			title="Workspaces Created Over Time"
			data={workspaceChartQuery.data}
			isLoading={workspaceChartQuery.isLoading}
		/>
	)
}
